module.exports = __webpack_public_path__ + "img/pos6_banner2.a1c5da85.jpg";